'use strict';

;( () => {

	document.addEventListener( 'alpine:init', () => {

		Alpine.data( 'pricingAccordion', () =>  ({

			items    : null,
			openItems: new Set(),

			init() {
				this.items = this.$el.querySelectorAll( '[data-accordion-item]' );
			},

			toggle( el ) {

				if ( this.openItems.has( el ) ) {
					this.openItems.delete( el );
					return;
				}

				this.openItems.add( el );
				return;
			},

			isOpen( el ) {
				return this.openItems.has( el );
			},

			get allOpen() {
				return 0 < this.items.length && [...this.items].every( el => this.openItems.has( el ) );
			},

			toggleAll() {

				if ( this.allOpen ) {
					this.openItems.clear();
					return;
				}

				this.openItems = new Set( this.items );
				return;
			}
		}) );
	});
})();
